import React, { useState, useEffect } from "react";
import "./WeatherForecast.css";
import axios from "axios";
import WeatherForecastDay from "./WeatherForecastDay";

export default function WeatherForecast(props) {
  let [loaded, setLoaded] = useState(false);
  let [forecast, setForecast] = useState(null);

  function handleResponse(response) {
    console.log("Forecast data:", response.data);
    // Group forecast data by day
    const dailyForecasts = {};
    response.data.list.forEach((item) => {
      const date = new Date(item.dt * 1000);
      const dayKey = date.toDateString();

      if (!dailyForecasts[dayKey]) {
        dailyForecasts[dayKey] = {
          dt: item.dt,
          temp: { min: item.main.temp_min, max: item.main.temp_max },
          weather: [item.weather[0]],
          humidity: item.main.humidity,
          wind: item.wind.speed,
        };
      } else {
        // Update min/max temps
        dailyForecasts[dayKey].temp.min = Math.min(
          dailyForecasts[dayKey].temp.min,
          item.main.temp_min,
        );
        dailyForecasts[dayKey].temp.max = Math.max(
          dailyForecasts[dayKey].temp.max,
          item.main.temp_max,
        );
      }
    });

    const forecastArray = Object.values(dailyForecasts).slice(0, 7);
    console.log("Processed forecast:", forecastArray);
    setForecast(forecastArray);
    setLoaded(true);
  }

  function load() {
    let apiKey = "21b0d521c54b5a7cbc3b4d1148791850";
    let longitude = props.coordinates.lon;
    let latitude = props.coordinates.lat;
    let apiUrl = `https://api.openweathermap.org/data/2.5/forecast?lat=${latitude}&lon=${longitude}&appid=${apiKey}&units=metric`;

    axios
      .get(apiUrl)
      .then(handleResponse)
      .catch((error) => {
        console.error(
          "Forecast API error:",
          error.response?.status,
          error.response?.data,
        );
      });
  }

  useEffect(() => {
    setLoaded(false);
  }, [props.coordinates]);

  if (loaded) {
    return (
      <div className="WeatherForecast">
        <div className="row">
          {forecast.map(function (dailyForecast, index) {
            if (index < 7) {
              return (
                <div className="col" key={index}>
                  <WeatherForecastDay data={dailyForecast} />
                </div>
              );
            }
            return null;
          })}
        </div>
      </div>
    );
  } else {
    if (props.coordinates) {
      load();
    }
    return null;
  }
}
